import { createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import { push } from 'connected-react-router'

import { RestApiService } from '@/services'
import { ApplicationState } from '@/state/root.models'
import { setLoadingFullAction } from '@/state/ui/global/slices/index.slices'

import { TwoFactorStatus } from '@/enums/two-factor-status.enum'
import routes from '@/routes'
import { decodeJWT } from '@/utils'

import { getLoggedInUserThunk } from './get-logged-in.thunk'
import ActionTypes from '../constants'
import { CheckTwoFactorPayload, CheckTwoFactorResponse } from '../models'

import {
  loginActionSuccess,
  setTwoFactorStatusAction,
  setUnauthorizedAction,
  setUserSessionAction,
} from '../slices/index.slices'

const apiService: RestApiService = Container.get(RestApiService)

const checkTwoFactorThunk = createAsyncThunk(
  ActionTypes.CHECK_TWO_FACTOR,
  async (payload: CheckTwoFactorPayload, thunkAPI) => {
    try {
      apiService.requestParams = {
        method: 'POST',
        endpoint: 'twoFactorAuthentication/validateCode',
        body: { code: payload.code || undefined, playerId: payload.playerId },
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: CheckTwoFactorResponse = await apiService.sendAuthData(
        auth.token || '',
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      if (!response.accessToken || !response.isCodeValid) {
        thunkAPI.dispatch(setTwoFactorStatusAction(TwoFactorStatus.ERROR))
      } else {
        thunkAPI.dispatch(
          loginActionSuccess({
            accessToken: response.accessToken || '',
          }),
        )

        thunkAPI.dispatch(push(routes.reports.INDEX))

        const { decoded, isValid } = decodeJWT(response.accessToken)

        if (isValid) {
          thunkAPI.dispatch(setUnauthorizedAction(true))
          thunkAPI.dispatch(setUserSessionAction(decoded))
          thunkAPI.dispatch(getLoggedInUserThunk())
        }
      }
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

export default checkTwoFactorThunk
